import {Button, Form, FormInstance, Upload, UploadFile} from "antd"
import React, {useEffect, useState} from "react"

import {UploadOutlined} from "@ant-design/icons"
import {RcFile, UploadChangeParam} from "antd/es/upload";

interface Props {
    readonly form: FormInstance
}

const UploadFileAudio = (props: Props) => {
    const [fileList, setFileList] = useState<UploadFile[]>([])

    const watchedFile = Form.useWatch("fileAudio", props.form);

    useEffect(() => {
        if (watchedFile && watchedFile.name && watchedFile.type) {
            setFileList([
                watchedFile
            ]);
        } else {
            setFileList([]);
        }
    }, [watchedFile]);

    const uploadProps = {
        accept: ".mp3,.wav",
        beforeUpload: (file: RcFile) => {
            const isMp3OrWav = file.name.endsWith(".mp3") || file.name.endsWith(".wav")
            const isSizeOk = file.size / 1024 / 1024 < 10

            if (!isMp3OrWav) {
                props.form.setFields([
                    {
                        name: "fileAudio",
                        errors: ["Sono consentiti solo file .mp3 o .wav."],
                    },
                ])
                return Upload.LIST_IGNORE
            }

            if (!isSizeOk) {
                props.form.setFields([
                    {
                        name: "fileAudio",
                        errors: ["La dimensione massima consentita è di 10MB."],
                    },
                ])
                return Upload.LIST_IGNORE
            }

            return false
        },
        onRemove: () => {
            setFileList([])
            props.form.setFieldValue("fileAudio", undefined)
            props.form.validateFields(['fileAudio'])
            return true
        },
        onChange({file}: UploadChangeParam) {
            if (file && file.name && file.type) {
                props.form.setFieldValue("fileAudio", file)
                props.form.validateFields(['fileAudio'])
            } else {
                props.form.setFieldValue("fileAudio", undefined)
            }
        },
        fileList,
        maxCount: 1
    }

    return (
        <Form.Item
            key={"fileAudio"}
            name="fileAudio"
        >
            <Upload listType="picture" {...uploadProps}>
                <Button icon={<UploadOutlined/>}>Carica musica propria</Button>
            </Upload>
        </Form.Item>
    )
}

export default UploadFileAudio
